import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import helpers from "helpers/helpers"
import moment from "moment"
import FullTable from "components/FullTable"
import settings from "settings"

const PressingTable = (props) => {
	if (settings.builderPortalOnlyMarketing) return ""
	let mode = props.mode
	let columns = [
		{
			Header: "Community",
			accessor: "community",
			filterMethod: (f, r) => helpers.tableText(f, r, "community"),
		},
		{
			Header: "Builder",
			accessor: "builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Address",
			accessor: "address",
			filterMethod: (f, r) => helpers.tableText(f, r, "address"),
		},
		...(mode === "developer"
			? [
					{
						Header: "Missing Data",
						accessor: "missingString",
						filterMethod: (f, r) => helpers.tableText(f, r, "missingString"),
					},
			  ]
			: []),
		...(mode === "salesperson"
			? [
					{
						Header: "Actions",
						accessor: "actions",
						className: "actions",
						filterable: false,
						minWidth: 250,
					},
			  ]
			: []),
	]
	let data = []
	let twoWeeks = moment().subtract(2, "weeks").unix()
	let bucket
	if (props.mode === "salesperson") {
		bucket = props.payload?.salespersonPayload?.lots?.current
	} else if (props.mode === "developer") {
		//bucket = props.payload?.exec?.lots
		bucket = props?.data?.allLots
	}
	if (!bucket) return ""
	_.forEach(bucket, (r) => {
		let start, complete, estimatedClosing, contractActions, profile
		let requirePaperworkBeforeClosing = settings.requirePaperworkBeforeClosing
		let hasPressing = false
		let needPaperwork = false
		let closing
		let property = _.find(props.payload.public.properties, { id: r.property })
		let missingString = ""
		let sales_reps = []
		// Legacy stuff probably never getting
		if(r.sale_date && r.sale_date < moment().subtract(2, "years").unix()) return
		if (r.sale_id && property.no_paperwork !== 1 && r.sale_date < twoWeeks) {
			_.forEach(r.documents, (v) => {
				if (["rejected", "awaiting"].includes(v.status)) {
					needPaperwork = true
				}
			})
			if (!r.documents) {
				needPaperwork = true
			}
			if (needPaperwork) {
				hasPressing = true
				missingString += "Buyer Paperwork,"
				profile = (
					<button className={`btn btn--attention`} onClick={() => props.buttonClick("buyerModal", r)}>
						Buyer Paperwork
					</button>
				)
			}
		}
		if (r.lot_status == "Contract" && r.estimated_closing < twoWeeks) {
			hasPressing = true
			missingString += "Estimated Close/Closing/Cancel,"
			estimatedClosing = (
				<button className={`btn btn--attention`} onClick={() => props.buttonClick("estimatedModal", r)}>
					Edit Estimated Closing
				</button>
			)
			if (r.sale_date && !r.closing_date) {
				closing = (
					<button className="btn" onClick={() => props.buttonClick("closingModal", r)}>
						Add Closing
					</button>
				)
				if (requirePaperworkBeforeClosing && needPaperwork) closing = null
			}
			contractActions = (
				<span>
					<button className="btn" onClick={() => props.buttonClick("bustoutModal", r)}>
						Cancel Contract
					</button>
					<button className="btn" onClick={() => props.buttonClick("transferModal", r)}>
						Transfer Lot
					</button>
					{closing}
				</span>
			)
		}
		if (
			(!r.start_date && r.missing_start && !settings?.disableBuilderConstructionStatus) ||
			r?.bad_data?.start_date
		) {
			hasPressing = true
			missingString += "Start Date,"
			start = (
				<button className={"btn btn--attention"} onClick={() => props.buttonClick("startModal", r)}>
					Add Start
				</button>
			)
		}
		if (r.start_date && !r.complete_date && r.missing_complete && !settings?.disableBuilderConstructionStatus) {
			hasPressing = true
			missingString += "Complete Date,"
			complete = (
				<button className={"btn btn--attention"} onClick={() => props.buttonClick("completeModal", r)}>
					Add Complete
				</button>
			)
		}
		if (!hasPressing) return
		let actions = (
			<div>
				{start}
				{complete}
				{estimatedClosing}
				{contractActions}
				{profile}
			</div>
		)
		let builder = _.find(props.payload.public.builders, { id: r.builder })
		missingString = _.trim(missingString, ",")
		data.push({
			community: property?.name || "",
			builder: builder?.name || "",
			address: r.address,
			actions,
			missingString,
		})
	})
	if (data.length == 0) return ""
	return (
		<>
			<h2 className="pt-0">
				<i className="fa-duotone fa-file-exclamation text-red-500 mr-2"></i> Pressing Data Checklist
			</h2>
			<FullTable
				data={data}
				columns={columns}
				name="entryDashboard__pressing"
				title="Pressing Data Checklist"
				classNames={"small"}
			/>
		</>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(PressingTable)
